import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emisija, mišri`,
  'consumption.energy': 'Energijos sąnaudos, mišrios',
  'consumption.fuel': 'Degalų sąnaudos, mišrios',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'Pateikti skaičiai buvo gauti laikantis nustatyto matavimo proceso. Jie yra NEDC CO2 vertės (ES) 2017/1153 reglamentą. Degalų sąnaudos buvo apskaičiuotos remiantis šiomis vertėmis. Elektros energijos sąnaudos buvo nustatytos remiantis direktyva 692/2008/EB.',
  'footnotes.emissions.appendix':
    'Norėdami gauti daugiau informacijos apie oficialias naujų lengvųjų automobilių degalų sąnaudas ir išmetamą CO2 kiekį, kreipkitės į įgaliotąjį Mercedes-Benz atstovą.',
  'search.input.label': 'Jūsų paieškos terminas / OnlineCode Configurator',
  'search.result.buy-online': 'Pirkite internetu',
  'search.results': 'Rezultatų nerasta | {count} paieškos rezultatas | {count} paieškos rezultatų',
  'search.results.backup': 'Tikslių atitikčių nerasta. Peržiūrėkite susijusius puslapius:',
  'search.results.count': '{count} paieškos rezultatų',
  'search.results.none.summary': 'Nėra šios paieškos rezultatų. Bandykite dar kartą naudodami kitą paieškos žodį.',
  'search.show-more': 'Rodyti daugiau',
  'search.unavailable': 'Paieška šiuo metu nepasiekiama.',
  'search.result.new': 'Nauja',

  'input.placeholder': 'Jūsų paieškos terminas / OnlineCode Configurator',

  'suggestions.all_search_results': 'Visi paieškos rezultatai',
  'suggestions.all_search_results_for': 'Parodyti visus rezultatus',
  'suggestions.in': 'esantys',

  all: 'All',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Passenger cars',
  VANS: 'Vans',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Dealer search',
  CONFIGURATOR: 'Bandomasis važiavimas',
  TEST_DRIVE: 'Test drive',
  VEHICLE_SEARCH: 'Used Cars',
  COLLECT: 'Collection & ACCESSORIES',
  CONNECT: 'Mercedes me Store',

  'search.result.consumption': 'Sąnaudos',
  'watch.video': 'Žiūrėti vaizdo įrašą',
  'input.recently': 'Neseniai ieškota',
  'input.help.title': 'Ko turėtumėte ieškoti?',
  'input.help.text':
    'Paieška pagal transporto priemonės rūšis, modelius, konfigūracijos kodus arba priedams, kitiems produktams ir informacijai',

  'search.result.grid': 'Tinklelis',
  'search.result.list': 'Sąrašas',

  // Empty result
  'support.check': 'Patikrinkite, ar nėra rašybos klaidų, arba pabandykite naudoti kitą terminą.',
  'support.no.results': 'Paieškos rezultatų pagal šį paieškos terminą nėra.',
  'support.no.results.term': 'Rezultatų nerasta.',
  'support.chat': 'Nerandate to, ko ieškote? Naudokite mūsų terminus.',
  'support.chat.with.us': 'Pagalba per internetinį pokalbį.',
};
